import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ValueProposition from './components/ValueProposition';
import TeamSection from './components/TeamSection';
import PartnerSection from './components/PartnerSection';
import Footer from './components/Footer';

const AppContainer = styled.div`
  min-height: 100vh;
  background: #0A3B2D;
  color: white;
  position: relative;
  overflow: hidden;
`;

const BackgroundGradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 70%);
  pointer-events: none;
`;

function App() {
  return (
    <Router>
      <AppContainer>
        <BackgroundGradient />
        <Navbar />
        <main>
          <section id="home">
            <Hero />
          </section>
          <section id="services">
            <ValueProposition />
          </section>
          <section id="about">
            <TeamSection />
          </section>
          <section id="contact">
            <PartnerSection />
          </section>
        </main>
        <Footer />
      </AppContainer>
    </Router>
  );
}

export default App; 